import {Address} from '@wix/auto_sdk_ecom_current-cart';

export class AddressModel {
  public country?: string;
  public countryFullname: string;
  public subdivision?: string;
  public subdivisionFullname: string;
  public city?: string;
  public postalCode: string;

  constructor(params: AddressModel) {
    this.country = params.country;
    this.countryFullname = params.countryFullname;
    this.subdivision = params.subdivision;
    this.subdivisionFullname = params.subdivisionFullname;
    this.city = params.city;
    this.postalCode = params.postalCode;
  }

  public static fromCartV1(address: Address) {
    return new AddressModel({
      country: address?.country,
      countryFullname: address?.countryFullname,
      subdivision: address?.subdivision,
      subdivisionFullname: address?.subdivisionFullname,
      city: address?.city,
      postalCode: address?.postalCode,
    });
  }
}
